<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 5v13.32A1.68 1.68 0 0118.32 20H5.68A1.68 1.68 0 014 18.32V5a1 1 0 011-1h14a1 1 0 011 1zM9 7.94A1.27 1.27 0 008.66 7a1.37 1.37 0 00-1-.35A1.42 1.42 0 006.7 7a1.2 1.2 0 00-.38.9 1.22 1.22 0 00.37.89 1.34 1.34 0 001 .36 1.37 1.37 0 001-.36A1.19 1.19 0 009 7.94zM6.47 17.4h2.4v-7.23h-2.4zm8.65 0h2.41v-4.15a3.45 3.45 0 00-.76-2.43 2.61 2.61 0 00-2-.82 2.44 2.44 0 00-2.18 1.22v-1.05H10.2v7.23h2.4v-4a1.67 1.67 0 01.08-.58 1.58 1.58 0 01.47-.62 1.15 1.15 0 01.77-.25c.8 0 1.2.54 1.2 1.63z"/></svg>